"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashierExpressAddressToEcomAddress = void 0;
var CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES = [
    'AS',
    'FM',
    'GU',
    'MP',
    'PW',
    'VI',
    'PR',
];
function cashierExpressAddressToEcomAddress(shippingAddress, billingAddress, countryCodes) {
    var _a, _b, _c, _d;
    var countryCodeOverride = null;
    var hasSubdivision = !!shippingAddress.state;
    if (shippingAddress.countryCode === 'C2') {
        countryCodeOverride = 'CN';
    }
    if (shippingAddress.countryCode === 'US' &&
        shippingAddress.state &&
        CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES.includes(shippingAddress.state)) {
        countryCodeOverride = shippingAddress.state;
        hasSubdivision = false;
    }
    var country2LettersCode = (_a = countryCodeOverride !== null && countryCodeOverride !== void 0 ? countryCodeOverride : shippingAddress.countryCode) !== null && _a !== void 0 ? _a : billingAddress.countryCode;
    var country3LettersCode = countryCodes.find(function (country) { return country.shortKey === country2LettersCode; }).key;
    return {
        country: country3LettersCode,
        city: shippingAddress.city,
        zipCode: shippingAddress.postalCode,
        addressLine1: shippingAddress.addressLine1,
        addressLine2: shippingAddress.addressLine2,
        name: {
            firstName: (_b = shippingAddress.firstName) !== null && _b !== void 0 ? _b : billingAddress.firstName,
            lastName: (_c = shippingAddress.lastName) !== null && _c !== void 0 ? _c : billingAddress.lastName,
        },
        subdivision: hasSubdivision ? country2LettersCode + "-" + shippingAddress.state : undefined,
        email: billingAddress.email,
        phoneNumber: (_d = shippingAddress.phone) !== null && _d !== void 0 ? _d : billingAddress.phone,
    };
}
exports.cashierExpressAddressToEcomAddress = cashierExpressAddressToEcomAddress;
//# sourceMappingURL=cashierExpressAddressToEcomAddress.js.map